import { z } from 'zod';

/**
 * Lifecycle status of a Profile (global admin-curated brand directory entry).
 *
 * - `active`   — usable when creating Clients
 * - `merged`   — superseded by another Profile; retained for audit
 * - `archived` — hidden from picker UI but resolvable for historical refs
 */
export const profileStatusSchema = z.enum(['active', 'merged', 'archived']);
export type ProfileStatus = z.infer<typeof profileStatusSchema>;

/**
 * Provenance of a Profile entry.
 *
 * - `admin`      — created manually via the admin "Brand Directory" UI
 * - `csv_import` — bulk-imported from a curated CSV
 * - `suggested`  — surfaced as a candidate (future workflow; not built here)
 */
export const profileSourceSchema = z.enum(['admin', 'csv_import', 'suggested']);
export type ProfileSource = z.infer<typeof profileSourceSchema>;
